import { Button } from '@zond/ui';
import { Plus } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { getLogo } from '../../../../utils/get-logo';
import { useGetProjects } from '../../projects/projects.queries';

export const EmptyUserReport: React.FC = () => {
  const { t } = useTranslation('reports');
  const navigate = useNavigate();
  const { workspaceId, projectId } = useParams();
  const { data: projects } = useGetProjects();

  const currentProject = projects?.find((p) => p.id === parseInt(projectId || ''));

  const handleAddUsers = () => {
    navigate(`/${workspaceId}/projects`);
  };

  const handleCreateProject = () => {
    navigate(`/${workspaceId}/projects`);
  };

  const isProjectExists = !!currentProject;

  return (
    <div className="h-[calc(100vh-64px)] flex items-center justify-center">
      <div className="bg-card rounded-lg shadow-lg p-8 max-w-[480px] w-full mx-4 text-center">
        <img
          src={getLogo()}
          alt={t('empty.logoAlt')}
          className="w-16 h-16 dark:border dark:border-border/20 dark:rounded-full mx-auto mb-6"
        />
        <h1 className="text-3xl font-bold mb-3 bg-gradient-to-r from-primary/90 to-primary bg-clip-text text-transparent">
          {isProjectExists ? t('empty.welcomeTitle') : t('empty.noProjectsTitle')}
        </h1>
        <p className="text-muted-foreground mb-6">
          {isProjectExists ? t('empty.welcomeDescription') : t('empty.noProjectsDescription')}
        </p>
        <Button
          onClick={isProjectExists ? handleAddUsers : handleCreateProject}
          size="lg"
          className="gap-2 shadow-lg hover:shadow-primary/25 transition-all hover:scale-105 bg-gradient-to-r from-primary to-primary/90"
        >
          <Plus className="h-5 w-5" />
          {isProjectExists ? t('empty.addUsers') : t('empty.createProject')}
        </Button>
      </div>
    </div>
  );
};
